<template>
  <div class="modal fade" tabindex="-1" role="dialog" data-backdrop="static" id="inboundUploadModal">
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <div class="modal-header header-dark">
          <h5 class="modal-title">Upload Inbound Order</h5>
        </div>
        <div class="modal-body">

          <vue-select
            v-if="!scan.ok"
            v-model="client"
            :options="clients"
            label="name"
          ></vue-select>
          <div v-if="client.id && !scan.ok" class="mt-4">
            <dropzone
              id="inboundFileUpload"
              :options="dropzoneOptions"
              @vdropzone-success="vdzSuccess"
              @vdropzone-error="vdzError"
            ></dropzone>
          </div>
          <div v-if="scan.ok">
            <h4>File Scan Results</h4>
            <div><strong>Format: </strong> {{ scan.ok ? 'Correct' : 'Error' }}</div>
            <div><strong>Lines: </strong> {{ scan.lines }}</div>
            <div><strong>Request ID: </strong> {{ scan.file_id }}</div>
            <div class="mt-4">Click <strong>Process</strong> to create these orders</div>

          </div>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-secondary" data-dismiss="modal"
            @click="cancel"
          >Cancel</button>
          <button
            v-if="!loading"
            :disabled="!valid" 
            class="btn btn-primary"
            @click="process"
          >
            <i class="fa fa-upload"></i> Process
          </button>
          <button v-else class="btn btn-primary" disabled>
            <i class="fa fa-spinner fa-spin"></i> Processing...
          </button>
          
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import VueSelect from 'vue-select'
import $ from 'jquery'
import Dropzone from 'vue2-dropzone'
import 'vue2-dropzone/dist/vue2Dropzone.min.css'

import clientStore from '@/stores/clients'
import client from '@/libs/client'
import auth from '@/libs/auth'

import api from '@/api'
import inboundStore from '@/stores/inbound'
import n from '@/libs/notifications'


export default {
  name: 'upload-modal',
  components: { VueSelect, Dropzone },
  props: { order: Object },

  data() {
    return {
      client: {},
      scan: {},
      loading: false,
    }
  },

  created() {
    this.fetchData()
  },

  computed: {
    dropzoneOptions() {
      return {
        url: api.baseUrl + '/inbound-orders/upload/' + this.client.id,
        thumbnailWidth: 150,
        thumbnailHeight: 75,
        maxFilesize: 0.5,
        headers: { "Authorization": auth.getToken() }
      }
    },

    clients() {
      return clientStore.state.clients
    },

    valid() {
      return this.scan.ok
    }
  },

  methods: {
    cancel() {
      this.client = {}
      this.scan = {}
    },

    vdzSuccess(file, res) {
      this.scan = res
    },

    vdzError(file, error) {
      alert(error)
    },

    reloadOrders() {
      api.get('/inbound-orders').then(res => {
        inboundStore.setOrders(res.data.orders)
      })
    },

    process() {
      if (this.valid) {
        this.loading = true
        api.post(`/inbound-orders/process-file/${this.scan.file_id}`).then(() => {
          $('#inboundUploadModal').modal('hide')
          n.success("Inbound order is being created.")
          this.loading = false
          setTimeout(this.reloadOrders, 2000)
        })
      }
    },

    fetchData() {
      client.all().then(res => {
        clientStore.setClients(res.data.clients)
      })
    }
  }
}
</script>